import { execAdmin } from '../utils';

const gql = String.raw;

interface DeleteColorPropertyResponse {
  partner: {
    deleteColorProperty: {
      success: boolean;
      error?: string;
    };
  };
}

interface DeleteColorPropertyVariables {
  partnerCode: string;
  id: number;
}

const DELETE_COLOR_PROPERTY_MUTATION = gql`
  mutation deleteColorProperty($partnerCode: String!, $id: Int!) {
    partner(code: $partnerCode) {
      deleteColorProperty(id: $id) {
        success
        error
      }
    }
  }
`;

export const deleteColorProperty = async ({
  id,
  partnerCode,
  token,
}: {
  id: number;
  partnerCode: string;
  token: string;
}): Promise<void> => {
  const variables: DeleteColorPropertyVariables = {
    partnerCode,
    id,
  };

  const response = await execAdmin<DeleteColorPropertyVariables, DeleteColorPropertyResponse>(
    DELETE_COLOR_PROPERTY_MUTATION,
    { variables }
  );

  if (!response.partner.deleteColorProperty.success) {
    throw new Error(
      response.partner.deleteColorProperty.error || 'Failed to delete color property'
    );
  }
};
